import { ApiError } from "@/types/types";

export function resolveCardSavedError({
  apiErr,
  listingId,
  attemptedState,
  updateSavedState,
}: {
  apiErr: ApiError;
  listingId: string;
  attemptedState: boolean; // true = save, false = unsave
  updateSavedState: (listingId: string, newState: boolean) => void;
}) {
  const code = apiErr?.code?.toUpperCase() ?? "";

  if (code === "ALREADYSAVED") {
    // Server says: the item is already saved → UI should show it as saved
    updateSavedState(listingId, true);
    return;
  }

  if (code === "ALREADYUNSAVED") {
    // Server says: item is already unsaved → UI should show it as unsaved
    updateSavedState(listingId, false);
    return;
  }

  // For all unknown errors → revert optimistic update
  updateSavedState(listingId, !attemptedState);
}
